/**
 * Sắp xếp máy theo SỐ trong mã ("M1" < "M2" < … < "M36"), không theo thứ tự
 * chữ (vốn cho M1 < M10 < M11 < M2 — sai).
 */

/** Số thứ tự máy từ mã "M<n>". Mã lạ → đẩy xuống cuối. */
export function machineIndex(code: string): number {
    const n = Number.parseInt(code.slice(1), 10)
    return Number.isNaN(n) ? Number.MAX_SAFE_INTEGER : n
}

/** So sánh 2 mã máy theo số, dùng cho Array.prototype.sort. */
export function compareMachineCode(a: string, b: string): number {
    return machineIndex(a) - machineIndex(b)
}
